export default "__VITE_ASSET__CXm5n5xU__";